import React from 'react';
import s from './BannerText.scss';

export type BannerTextProps = {
  text?: string;
  isMobile?: boolean;
};

export const BannerText = ({
  text = '',
  isMobile = false,
}: BannerTextProps) => {
  if (isMobile) {
    const bannerParts = text.split('<br>');
    return (
      <p className={s.bannerText}>
        {bannerParts.map((part, index) => (
          <span key={`${part}-${index}`}>
            {part}
            {index < bannerParts.length - 1 && <br />}
          </span>
        ))}
      </p>
    );
  }
  const cleanedText = text.replace(/<br>/g, '');
  return cleanedText.replace(/ {2}/g, ' ');
};

export default BannerText;
